// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanCodeValidationResponseDto
 */
export interface IPlanCodeValidationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IPlanCodeValidationResponseDto
     */
    plan_code?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanCodeValidationResponseDto
     */
    is_valid?: boolean;
}

/**
 * Check if a given object implements the IPlanCodeValidationResponseDto interface.
 */
export function instanceOfIPlanCodeValidationResponseDto(value: object): value is IPlanCodeValidationResponseDto {
    return true;
}

export function IPlanCodeValidationResponseDtoFromJSON(json: any): IPlanCodeValidationResponseDto {
    return IPlanCodeValidationResponseDtoFromJSONTyped(json, false);
}

export function IPlanCodeValidationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanCodeValidationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'is_valid': json['is_valid'] == null ? undefined : json['is_valid'],
    };
}

export function IPlanCodeValidationResponseDtoToJSON(json: any): IPlanCodeValidationResponseDto {
    return IPlanCodeValidationResponseDtoToJSONTyped(json, false);
}

export function IPlanCodeValidationResponseDtoToJSONTyped(value?: IPlanCodeValidationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_code': value['plan_code'],
        'is_valid': value['is_valid'],
    };
}

